import React from "react";
import styled from "styled-components";
import { useGlobalContext } from "../useContext"
// import { FaHtml5, FaNode } from "react-icons/fa";
// import { FaCss3Alt } from "react-icons/fa";
// import { SiTailwindcss } from "react-icons/si";
// import { IoLogoJavascript } from "react-icons/io";
// import { FaReact } from "react-icons/fa";
// import { FaNodeJs } from "react-icons/fa";
// import { SiMongodb } from "react-icons/si";
import { gsap } from "gsap";

const Home = () => {
  const {isSidebar}=useGlobalContext();
  
  //animation
  const refs = React.useRef([]);

  const addToRefs = (el) => {
    if( el && !refs.current.includes(el)) {
      refs.current.push(el);
    }
  }

  React.useEffect(()=> {
refs.current.forEach((el, index)=> {
  const text=el.textContent.split("");
  el.innerHTML="";

  text.forEach((char, index)=> {
    const span = document.createElement("span");
    span.textContent = char === " " ? "\u00A0" : char;
    span.style.display="inline-block";
    el.appendChild(span);
  })

  const chars = document.querySelectorAll("span");
  gsap.fromTo(chars, {opacity: 0}, {opacity: 1, stagger: 0.05, ease: "easeInOut"})
});

  }, []);

  return (
    <Wrapper
      className={
        !isSidebar ? "page-100 home__container section__center" : "hidden"
      } id="home">
      <article className="home__content">
        <div>
          <h1 className="title title_1" ref={addToRefs}>Full Stack</h1>
        </div>

        <div><h1 ref={addToRefs}
        className="title title_2" style={{paddingBottom: "1rem"}}>Developer</h1>
        </div>

        <div>
        <p className="title_3" ref={addToRefs}
        style={{ paddingTop: "1.5rem", paddingBottom: "1rem", fontSize: "1.1rem"}}>
        Hi, I'm Mihaela</p>
        </div>

        <div>
        <p className="title_4" ref={addToRefs}
        style={{ paddingBottom: "2.5rem", fontSize: "1.1rem" }}>
        a dedicated Developer & Designer.</p>
        </div>

        <div className="animated-div">
        <p className="title-3"
          style={{ paddingBottom: "1rem", fontSize: "1.1rem"}}>Dream it, then make it happen!</p>
        <a
        href="#contact" className="btn__contact">
          <div>Get In Touch</div>
        </a>
        </div>

      </article>
    </Wrapper>
  );
};

const Wrapper = styled.header`
  padding: 3rem;
  height: calc(100dvh - 5rem);
  background-color: var(--clr-navy-7);
  background-image: url("assets/background.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;
  overflow: hidden;

  .home__content {
    background: transparent;
    position: absolute;
    left: 16%;
    top: 12%;
    width: max-content;
    overflow: hidden;
  }

  

  .title {
    letter-spacing: 0.09rem;
    color: var(--clr-title);
    overflow: hidden;
    white-space: nowrap;
    font-size: 3rem;
  }

  p {
    color: var(--clr-grey-8);
    letter-spacing: 0.04rem;
    overflow: hidden;
    white-space: nowrap;
  }

  .name {
    font-family: "Roboto", sans-serif;
    color: var(--clr-grey-8);
    font-weight: bold;
  }

  .title-4 {
    transform: translateY(500px);
    opacity: 0;
    animation: textAnimation 4.75s ease-in-out forwards;
  }

  @keyframes textAnimation {
    from {
      transform: translateY(500px);
    opacity: 0;
    }
    to {
      transform: translateY(0);
    opacity: 1;
    }
  }

  .btn__contact {
    margin: 0;
    overflow: hidden;
    white-space: nowrap;
    animation:buttonAnimation 5s ease-in-out forwards;
  }

  @keyframes buttonAnimation {
    from {
      transform: translateY(500px);
    opacity: 0;
    }
    to {
      transform: translateY(0);
    opacity: 1;
    }
  }

  @media only screen and (max-width: 992px) {
    .home__container {
    position: relative;
    }
    .home__content {
      padding: 0;    
      left: 50%;
      transform: translateX(-50%);
    }
    .title {
      text-align: center;
    }
    p {
      text-align: center;
      font-size: 1rem;
    }
    .btn__contact {
      margin: 0 auto;
    }
  }

  @media (max-width: 380px) {
    .title {
      font-size: 1.8rem;
    }
    .home__container {
      height: 100%;
    }
    .home__content {
      height: 100%;
    }

    p {
      font-size: 1rem;
      text-align: center;
      max-width: 260px;
    }
    .title_4 {
      max-width: 280px;
      width: 90%;
      margin: 0 auto;
      text-align: center;
      white-space: normal;
      padding: 0 0.5rem;
      word-wrap: break-word;
      overflow-wrap: break-word;
      hyphens: auto;
    }
  }
`;

export default Home;
